(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foen-luxproduct-page-lux"] && !Shopify.designMode) return;
  try {
    

/*
 * Progressive UI enhancement for the supplied Prestige product section.
 * No fetch monkey-patching. No second cart/add request. No product JSON bulk export.
 * Successful confirmation comes ONLY from Maestrooo's documented variant:add event.
 */
if (!customElements.get('foen-product-experience-v499')) {
  customElements.define('foen-product-experience-v499', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const configElement = this.querySelector('[data-foen-config]');
      if (!configElement) {
        if ((this.connectAttempts || 0) < 3) {
          this.connectAttempts = (this.connectAttempts || 0) + 1;
          this.connectRetry = requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
        }
        return;
      }
      this.connectAttempts = 0;
      try { this.config = JSON.parse(configElement.textContent); } catch (_) { return; }
      this.controller = new AbortController();
      this.optionGroups = new Map();
      this.orderPatches = new Map();
      this.orderVisibilityDirty = new Set();
      this.orderDeferred = false;
      this.optionPointerGuardUntil = 0;
      this.orderedLeaves = [];
      this.timers = new Set();
      this.pending = null;
      this.frame = 0;
      this.galleryFrame = 0;
      this.refreshFrame = 0;
      this.polishFrame = 0;
      this.optionFocus = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('keydown', event => {
        if (!(event.target instanceof Element) || event.defaultPrevented || !event.target.closest('[data-foen-gallery-tools]') || event.target.closest('input,select,textarea,video,model-viewer,dialog')) return;
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        const slides = this.visibleSlides();
        const index = slides.indexOf(this.currentSlide);
        const target = slides[index + (event.key === 'ArrowRight' ? 1 : -1)];
        if (target) { event.preventDefault(); event.stopPropagation(); this.selectMedia(target.dataset.mediaId); }
      }, { signal });
      this.addEventListener('submit', event => this.onSubmit(event), { capture: true, signal });
      this.addEventListener('change', () => { this.optionPointerGuardUntil = 0; this.scheduleRefresh(); this.updateMadeToOrder(); }, { signal });
      document.addEventListener('variant:add', event => this.onAdded(event), { signal });
      document.addEventListener('cart:error', event => this.onCartError(event), { signal });
      document.addEventListener('variant:change', event => {
        if (event.target instanceof Node && event.target !== this.form && !this.contains(event.target)) return;
        this.scheduleRefresh();
        this.schedulePolish();
        // Prestige can finish its partial product rerender after the variant event.
        // Re-run the visual normalization after those DOM updates without touching variant logic.
        this.later(() => this.schedulePolish(), 60);
        this.later(() => this.schedulePolish(), 220);
        this.currentVariant = event.detail?.variant || null;
        // Keep only the DESCRIPTION copy in sync with native Shopify variant changes.
        this.updateVariantDescription(this.currentVariant?.id);
        this.updateMadeToOrder();
        const id = event.detail?.variant?.featured_media?.id;
        if (id) this.later(() => this.selectMedia(String(id), true), 100);
      }, { signal });
      document.addEventListener('dialog:after-show', () => {
        if (this.overlayOpen()) this.hideConfirmation();
        this.scheduleSticky();
      }, { signal });
      document.addEventListener('dialog:after-hide', () => this.scheduleSticky(), { signal });
      document.addEventListener('keydown', event => this.onOrderTab(event), { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.dismissConfirmation();
        if (['Escape', 'Enter'].includes(event.key) && this.orderDeferred) {
          this.optionPointerGuardUntil = 0;
          this.later(() => this.scheduleRefresh(), 0);
        }
      }, { signal });
      window.addEventListener('scroll', () => this.scheduleSticky(), { passive: true, signal });
      window.addEventListener('resize', () => { if (this.info) this.orderVisibilityDirty.add(this.info); this.scheduleSticky(); this.scheduleGallery(); this.scheduleRefresh(); }, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', () => this.scheduleSticky(), { passive: true, signal });
      this.addEventListener('focusin', event => {
        const target = event.target;
        if (target instanceof Element && target.matches('[data-foen-variant-dropdown]')) {
          this.optionFocus = { id: target.id, node: target, time: Date.now() };
        }
        this.scheduleSticky();
      }, { signal });
      document.addEventListener('pointerdown', event => {
        if (!event.target.closest?.('[data-foen-option-group]')) this.optionFocus = null;
        const picker = event.target.closest?.('select,button.select,[role="combobox"]');
        if (picker && this.info?.contains(picker)) {
          // Let the native pointer default action open the picker before any layout work.
          // Never call showPicker(): Shopify editor previews can be cross-origin frames.
          this.optionPointerGuardUntil = Date.now() + 180;
          this.later(() => { if (this.orderDeferred) this.scheduleRefresh(); }, 200);
        } else if (this.orderDeferred) {
          this.optionPointerGuardUntil = 0;
          this.later(() => this.scheduleRefresh(), 0);
        }
      }, { capture: true, signal });
      document.addEventListener('focusin', event => {
        if (event.target instanceof Element && !event.target.closest('[data-foen-option-group]')) this.optionFocus = null;
      }, { signal });
      this.addEventListener('reset', () => this.later(() => this.scheduleRefresh(), 0), { signal });
      this.addEventListener('focusout', () => this.later(() => {
        this.scheduleSticky();
        if (this.orderDeferred) this.scheduleRefresh();
      }, 0), { signal });
      this.mutations = new MutationObserver(records => {
        let structuralChange = false;
        let needsPolish = false;

        for (const record of records) {
          const owner = record.target instanceof Element ? record.target : record.target.parentElement;
          if (owner?.closest('[data-foen-option-group]')) continue;
          if (record.type === 'attributes') {
            // Ignore only our own layout/style annotations, not app visibility changes.
            if (['class','style'].includes(record.attributeName)) {
              if (!owner?.closest('.product-info')) continue;
              if (record.attributeName === 'style' && this.spacingStyleWrites?.get(owner) === owner.getAttribute('style')) continue;
              const clean = value => record.attributeName === 'class'
                ? String(value || '').split(/\s+/).filter(name => name && !name.startsWith('foen-')).sort().join(' ')
                : String(value || '').replace(/--foen-flow-order\s*:[^;]*(?:;|$)/g, '').replace(/\s+/g, '').replace(/;+$/,'');
              if (clean(record.oldValue) !== clean(owner.getAttribute(record.attributeName))) {
                structuralChange = true;
                this.orderVisibilityDirty.add(owner);
              }
              continue;
            }
            if (['hidden','aria-hidden','inert'].includes(record.attributeName) && owner?.closest('.product-info')) structuralChange = true;
            if (record.target.matches?.('input, option, select, fieldset')) { needsPolish = true; structuralChange = true; }
            continue;
          }
          if (record.type === 'characterData') {
            const parent = record.target.parentElement;
            if (parent?.closest('.foen-layout-void,.foen-spacing-empty,.foen-order-item[data-foen-flow-kind=other],[data-foen-flow-kind=purchase]')) structuralChange = true;
            if (parent?.closest('sale-price, compare-at-price, [data-foen-confirm-price], .variant-picker__option, .foen-compact-option, .gpo-label')) needsPolish = true;
            continue;
          }

          if (record.type === 'childList') {
            const changedNodes = [...record.addedNodes, ...record.removedNodes];
            if (changedNodes.some(node => node.nodeType === 1)) structuralChange = true;

            const target = record.target instanceof Element ? record.target : record.target.parentElement;
            if (target?.closest('sale-price, compare-at-price, [data-foen-confirm-price], .variant-picker__option')) needsPolish = true;
            if (changedNodes.some(node => {
              if (node.nodeType === 3) return true;
              return node.nodeType === 1 && (
                node.matches?.('sale-price, compare-at-price, .variant-picker__option') ||
                node.querySelector?.('sale-price, compare-at-price, .variant-picker__option')
              );
            })) needsPolish = true;
          }
        }

        if (structuralChange) this.scheduleRefresh();
        if (needsPolish) this.schedulePolish();
      });
      this.mutations.observe(this, { childList: true, characterData: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['selected','checked','disabled','required','hidden','value','class','style','aria-hidden','inert'] });
      this.guide = this.querySelector('[data-foen-guide]');
      this.guide?.addEventListener('close', () => this.onGuideClose(), { signal });
      this.guide?.addEventListener('click', event => {
        if (event.target !== this.guide) return;
        const r = this.guide.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.guide.close();
      }, { signal });
      this.querySelectorAll('[data-foen-service]').forEach(dialog => {
        dialog.addEventListener('close', () => {
          this.restoreScroll();
          if (this.serviceOpener?.isConnected) this.serviceOpener.focus({ preventScroll: true });
          this.scheduleSticky();
        }, { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const block = event.target instanceof Element ? event.target : null;
        block?.querySelectorAll('details').forEach(detail => { detail.open = true; });
        block?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }, { signal });
      this.refresh();
      this.later(() => this.scheduleRefresh(), 250);
      this.later(() => this.scheduleRefresh(), 800);
      this.later(() => this.scheduleRefresh(), 1600);
      this.later(() => this.scheduleRefresh(), 3000);
      this.rememberProduct();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.galleryController?.abort(); this.galleryController = null;
      this.carousel = null; this.mainButton = null; this.info = null;
      cancelAnimationFrame(this.connectRetry);
      this.mutations?.disconnect(); this.galleryMutations?.disconnect(); this.resizeObserver?.disconnect();
      this.ctaObserver?.disconnect(); this.footerObserver?.disconnect();
      this.timers?.forEach(id => clearTimeout(id));
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.galleryFrame); cancelAnimationFrame(this.refreshFrame); cancelAnimationFrame(this.polishFrame);
      if (this.guide?.open) this.guide.close();
      this.querySelectorAll('[data-foen-service][open]').forEach(dialog => dialog.close());
      this.teardownOptions();
      this.restoreOptionOrder();
      this.querySelectorAll('.foen-layout-void').forEach(node => node.classList.remove('foen-layout-void'));
      this.restoreScroll();
    }
    later(fn, ms) {
      const id = setTimeout(() => { this.timers.delete(id); if (this.isConnected) fn(); }, ms);
      this.timers.add(id); return id;
    }
    scheduleRefresh() {
      if (this.refreshFrame) return;
      this.refreshFrame = requestAnimationFrame(() => { this.refreshFrame = 0; if (this.isConnected) this.refresh(); });
    }
    schedulePolish() {
      if (this.polishFrame) return;
      this.polishFrame = requestAnimationFrame(() => {
        this.polishFrame = 0;
        if (!this.isConnected) return;
        this.normalizePrices();
        this.hideDuplicateOptionValues();
        this.enhanceOptions();
        this.normalizeLayoutSpacing();
        this.applyOptionOrder();
      });
    }
    refresh() {
      this.form = document.getElementById(this.dataset.formId);
      if (this.form && !this.contains(this.form)) this.form = null;
      const info = this.querySelector('.product-info');
      const mainButton = info?.querySelector('buy-buttons button[type="submit"], .buy-buttons button[type="submit"]') ||
        (this.form ? [...this.form.elements].find(el => el.matches?.('button[type="submit"]') && !el.closest('[data-foen-sticky]')) : null);
      if (mainButton !== this.mainButton || info !== this.info) {
        this.mainButton = mainButton; this.info = info;
        this.resizeObserver?.disconnect(); this.ctaObserver?.disconnect();
        if ('ResizeObserver' in window && info) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleSticky()); this.resizeObserver.observe(info);
        }
        if ('IntersectionObserver' in window && mainButton) {
          this.ctaObserver = new IntersectionObserver(() => this.scheduleSticky(), { threshold: [0, 1] }); this.ctaObserver.observe(mainButton);
        }
      }
      this.sticky = this.querySelector('[data-foen-sticky]');
      this.footer = document.querySelector('footer');
      this.hideLegacyFeedback();
      this.polishPurchaseHeader();
      this.updateAdvisorLink();
      this.relocateNarrative();
      this.normalizeLayoutSpacing();
      this.updateMadeToOrder();
      this.syncVariantDescription();
      this.normalizePrices();
      this.enhanceOptions();
      this.hideDuplicateOptionValues();
      this.applyOptionOrder();
      this.enhanceGallery(); this.scheduleSticky();
      if (this.pending?.started && !this.pending.timedOut) this.setStatus(this.config.strings.adding, 'pending');
    }

    syncVariantDescription() {
      const data = this.querySelector('[data-foen-variant-description-map]');
      if (!data) return;
      let descriptions;
      try { descriptions = JSON.parse(data.textContent); } catch (_) { return; }

      // Read only genuine Shopify variant options (not Globo inputs).
      // FOEN's Single/Pair visual selector clicks Prestige's native checked radio.
      const selectedOptions = new Map();
      const nativePicker = this.info?.querySelector('variant-picker');
      nativePicker?.querySelectorAll('input[type="radio"][data-option-position]:checked, select[data-option-position]').forEach(input => {
        const position = Number(input.dataset.optionPosition);
        if (Number.isInteger(position) && position > 0 && input.value) {
          selectedOptions.set(position - 1, String(input.value));
        }
      });
      let selectedId = '';
      if (selectedOptions.size) {
        const matches = Object.entries(descriptions).filter(([, entry]) =>
          entry && Array.isArray(entry.options) &&
          [...selectedOptions].every(([index, value]) => String(entry.options[index]) === value)
        );
        if (matches.length === 1) selectedId = matches[0][0];
      }
      if (!selectedId) {
        // Form variant ID may update later than Single/Pair; only use it if
        // Shopify's selected option values cannot identify one unique variant.
        const idInput = this.form?.querySelector('input[name="id"]') ||
          this.querySelector('form input[name="id"]');
        selectedId = String(idInput?.value || this.currentVariant?.id || '');
      }
      if (selectedId) this.updateVariantDescription(selectedId, descriptions);
    }

    updateVariantDescription(variantId, parsedDescriptions = null) {
      if (!variantId) return;
      const accordion = this.querySelector('[data-foen-product-description]');
      const target = accordion?.querySelector('[data-foen-product-copy]');
      const data = this.querySelector('[data-foen-variant-description-map]');
      if (!target || !data) return;
      let descriptions = parsedDescriptions;
      if (!descriptions) {
        try { descriptions = JSON.parse(data.textContent); } catch (_) { return; }
      }
      const entry = descriptions[String(variantId)];
      if (!entry) return;
      const html = String(typeof entry === 'string' ? entry : entry.html || '');
      const key = String(variantId);
      // Avoid continuous DOM rewrites in FOEN's MutationObserver after HTML normalization.
      if (target.dataset.foenDescriptionVariantId !== key) {
        target.innerHTML = html;
        target.dataset.foenDescriptionVariantId = key;
      }
      const shouldHide = !html.trim();
      if (accordion.hidden !== shouldHide) accordion.hidden = shouldHide;
    }

    normalizePrices() {
      if (!this.config.dotPriceGrouping && !this.config.trimPriceZeros) return;
      if (!this.priceTextCache) this.priceTextCache = new WeakMap();
      const formatNumber = raw => {
        let text = raw.replace(/[\s\u00a0\u202f]/g, '');
        const separators = [...text.matchAll(/[.,]/g)];
        const last = separators.at(-1);
        let fraction = '';
        let integer = text;
        let currencyDecimals = 2;
        try { currencyDecimals = new Intl.NumberFormat('en', { style:'currency', currency:this.config.currency || 'TRY' }).resolvedOptions().maximumFractionDigits; } catch (_) {}
        if (last) {
          const tail = text.slice(last.index + 1);
          const both = text.includes('.') && text.includes(',');
          const isDecimal = /^\d+$/.test(tail) && (tail.length === 1 || tail.length === 2 || (both && tail.length <= Math.max(currencyDecimals, 2)) || (currencyDecimals === 3 && tail.length === 3 && separators.length === 1));
          if (isDecimal) { integer = text.slice(0, last.index); fraction = tail; }
        }
        integer = integer.replace(/[.,]/g, '');
        if (!/^[+-]?\d+$/.test(integer)) return raw;
        const sign = integer.startsWith('-') ? '-' : (integer.startsWith('+') ? '+' : '');
        integer = integer.replace(/^[+-]/, '').replace(/^0+(?=\d)/, '');
        if (this.config.trimPriceZeros && fraction && /^0+$/.test(fraction)) fraction = '';
        const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return sign + grouped + (fraction ? ',' + fraction : '');
      };
      this.querySelectorAll('sale-price, compare-at-price, [data-foen-confirm-price]').forEach(element => {
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        const nodes=[];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        for (const node of nodes) {
          if (node.parentElement?.closest('script,style,.sr-only,.visually-hidden,unit-price')) continue;
          const original = node.nodeValue || '';
          if (this.priceTextCache.get(node) === original) continue;
          let normalized = original;
          if (this.config.dotPriceGrouping) {
            normalized = normalized.replace(/[+-]?\d(?:[\d.,\u00a0\u202f ]*\d)?/g, formatNumber);
            normalized = normalized.replace(/(\d)\s*(TL|TRY|\u20ba|[A-Z]{3})(?=\s|$)/g, (_,n,c) => n+'\u00a0'+(c==='TRY' ? 'TL' : c));
            // Currency can be in its own span. Keep a real, non-breaking gap there too.
            if (/^\s*(TL|TRY|\u20ba|[A-Z]{3})\s*$/.test(normalized)) {
              const index=nodes.indexOf(node);
              const previous=nodes.slice(0,index).map(n=>n.nodeValue).join('').trimEnd();
              if (/\d$/.test(previous)) normalized='\u00a0'+normalized.trim().replace(/^TRY$/,'TL');
            }
          } else {
            normalized = normalized.replace(/[.,]00(?=\s*(?:TL|TRY|\u20ba|[A-Z]{3})?\s*$)/u,'');
          }
          if (normalized !== original) node.nodeValue = normalized;
          this.priceTextCache.set(node, normalized);
        }
      });
    }

    // V4.9.1: one source of truth. App fields are styled IN PLACE, never cloned,
    // moved out of their application wrapper, disabled, or mapped to variant IDs.
    normalizeLayoutSpacing() {
      if (!this.info || this.optionPickerOpen()) return;
      const hasContent = node => {
        if (node.nodeType === Node.TEXT_NODE) return Boolean(node.textContent.trim());
        if (!(node instanceof Element)) return false;
        if (node.matches('script,style,template,noscript,input[type="hidden"]')) return false;
        if (!['DIV','SPAN','P','BR','FORM','PRODUCT-FORM'].includes(node.tagName) ||
            node.hasAttribute('tabindex') || node.hasAttribute('role') || node.isContentEditable ||
            node.matches('[onclick],[onpointerdown],.gpo-element,.gpo-form__group,[data-app],[data-gpo-element]')) return true;
        return [...node.childNodes].some(hasContent);
      };
      this.info.querySelectorAll('.product-info__block-item[data-block-type="liquid"],.product-info__block-item[data-block-type="text"],product-form,form').forEach(node => {
        // A real control, link, custom widget, image or nonempty text prevents hiding.
        const empty = [...node.childNodes].every(child => !hasContent(child));
        if (node.classList.contains('foen-layout-void') !== empty) node.classList.toggle('foen-layout-void', empty);
      });
    }
    // V4.9.9: static box-model normalization; no measured/negative offset.
    // A row includes its real external caption. The requested visible external gap is 8px.
    // After static cleanup, a measured reconciliation below enforces 8px edge-to-edge.
    restoreFixedSpacing() {
      for (const [node, names] of this.spacingClasses || []) {
        for (const name of names) node.classList.remove(name);
      }
      for (const [node, rules] of this.spacingStyles || []) {
        for (const [property, saved] of rules) {
          if (node.style.getPropertyValue(property) !== saved.applied) continue;
          if (saved.value) node.style.setProperty(property, saved.value, saved.priority);
          else node.style.removeProperty(property);
        }
        this.spacingStyleWrites?.set(node, node.getAttribute('style'));
      }
      this.spacingClasses = new Map(); this.spacingStyles = new Map();
    }
    spacingBoxEmpty(node) {
      if (node.nodeType === Node.TEXT_NODE) return !node.textContent.trim();
      if (!(node instanceof Element)) return true;
      if (node.matches('script,style,template,noscript,input[type="hidden"],link,meta')) return true;
      if (!node.matches('div,span,p,br') || node.shadowRoot || node.isContentEditable ||
          node.matches('[tabindex],[onclick],[onpointerdown],[onmousedown]') ||
          (node.hasAttribute('role') && !['status','alert','log','presentation','none'].includes(node.getAttribute('role')))) return false;
      if (getComputedStyle(node).backgroundImage !== 'none') return false;
      for (const pseudo of ['::before','::after']) {
        const p = getComputedStyle(node, pseudo);
        if (p.content && !['none','normal','""',"''"].includes(p.content)) return false;
        if (p.backgroundImage !== 'none') return false;
      }
      return [...node.childNodes].every(child => this.spacingBoxEmpty(child));
    }
    normalizeFixedSpacing() {
      if (!this.orderRoot?.isConnected || !this.mainButton?.isConnected || this.optionPickerOpen()) return;
      const classes = new Map(), styles = new Map();
      const mark = (node, name) => {
        const names = classes.get(node) || new Set(); names.add(name); classes.set(node,names);
      };
      const own = (node, property, value) => {
        const rules = styles.get(node) || new Map(); rules.set(property,value); styles.set(node,rules);
      };
      const margins = (node, top = '0px') => {
        own(node,'margin-top',top); own(node,'margin-bottom','0px');
        own(node,'margin-block-start',top); own(node,'margin-block-end','0px');
      };
      const trim = node => {
        margins(node);
        for (const prop of ['padding-top','padding-bottom','padding-block-start','padding-block-end','min-height']) own(node,prop,'0px');
        own(node,'height','auto'); own(node,'row-gap','0px');
      };
      const emptyBox = node => {
        mark(node,'foen-spacing-empty'); trim(node);
        // Keep live-region semantics. Remove only the blank reservation, never
        // display:none; the class is removed as soon as real content is inserted.
        own(node,'height','0px'); own(node,'font-size','0px'); own(node,'line-height','0px');
        own(node,'border-top-width','0px'); own(node,'border-bottom-width','0px');
      };
      for (const {node} of this.orderedLeaves || []) {
        if (node.dataset.foenFlowKind === 'other' && this.spacingBoxEmpty(node)) emptyBox(node);
        if (!node.classList.contains('foen-order-field') || !this.orderNodeVisible(node,this.orderRoot)) continue;
        mark(node,'foen-spacing-field'); trim(node); margins(node,'8px');
        const controls = [...node.querySelectorAll('select,button.select[aria-controls],[role="combobox"]')].filter(control => {
          if (control.closest('.foen-native-source-hidden,dialog,x-popover,[hidden],[inert]')) return false;
          if (control instanceof HTMLSelectElement && (control.multiple || control.size > 1 || ['id','selling_plan','quantity'].includes(control.name))) return false;
          return this.orderNodeVisible(control,node);
        });
        if (controls.length !== 1) continue; // Unknown/multi-control widgets stay native.
        const control = controls[0];
        mark(control,'foen-spacing-control'); margins(control);
        const header = node.querySelector('.variant-picker__option-info,.gpo-label,legend,label[for]');
        const path = new Set();
        const addPath = leaf => {
          for (let parent=leaf?.parentElement; parent && parent!==node; parent=parent.parentElement) {
            if (!parent.matches('div,span,p') || parent.shadowRoot || parent.hasAttribute('role') || parent.isContentEditable) break;
            path.add(parent);
          }
        };
        addPath(control);
        if (header && !header.contains(control)) {
          addPath(header); mark(header,'foen-spacing-caption'); margins(header);
          own(header,'margin-bottom','4px'); own(header,'margin-block-end','4px');
        }
        for (const parent of path) { mark(parent,'foen-spacing-path'); trim(parent); }
        // Native select wrappers must not keep an inline baseline/line-height gap.
        // Do not alter the display/hidden state of the application's actual select.
        for (const child of node.querySelectorAll('div,span,p,br')) {
          if (child===header || header?.contains(child) || child.contains(control) || (header && child.contains(header))) continue;
          if (this.spacingBoxEmpty(child)) emptyBox(child);
        }
      }
      mark(this.mainButton,'foen-spacing-purchase'); margins(this.mainButton,'8px');
      // A bridge has no physical box. Empty clearfix pseudo-elements must not
      // become anonymous flex items between the last field and the submit button.
      for (const bridge of this.orderRoot.querySelectorAll('.foen-order-bridge')) {
        for (const [pseudo,name] of [['::before','foen-spacing-no-before'],['::after','foen-spacing-no-after']]) {
          const style = getComputedStyle(bridge,pseudo);
          if (['none','normal','""',"''"].includes(style.content) && style.backgroundImage==='none') mark(bridge,name);
        }
      }
      // Idempotent reconciliation: unchanged ancestors are never torn down, and
      // no layout writes occur while a native/app picker is open.
      for (const [node, old] of this.spacingClasses || []) {
        for (const name of old) if (!classes.get(node)?.has(name)) node.classList.remove(name);
      }
      for (const [node, next] of classes) {
        for (const name of next) if (!node.classList.contains(name)) node.classList.add(name);
      }
      this.spacingStyleWrites ||= new WeakMap();
      for (const [node, old] of this.spacingStyles || []) {
        for (const [property,saved] of old) {
          if (styles.get(node)?.has(property) || node.style.getPropertyValue(property)!==saved.applied) continue;
          if (saved.value) node.style.setProperty(property,saved.value,saved.priority);
          else node.style.removeProperty(property);
        }
        this.spacingStyleWrites.set(node,node.getAttribute('style'));
      }
      const savedStyles = new Map();
      for (const [node,rules] of styles) {
        const savedRules = new Map();
        for (const [property,value] of rules) {
          const previous=this.spacingStyles?.get(node)?.get(property);
          const current=node.style.getPropertyValue(property), priority=node.style.getPropertyPriority(property);
          const saved=previous && current===previous.applied ? previous : {value:current,priority};
          if (current!==value || priority!=='important') node.style.setProperty(property,value,'important');
          savedRules.set(property,{...saved,applied:node.style.getPropertyValue(property)});
        }
        savedStyles.set(node,savedRules);
        this.spacingStyleWrites.set(node,node.getAttribute('style'));
      }
      this.spacingStyles=savedStyles; this.spacingClasses=classes;
    }
    /* V4.9.10.6: robust mixed Shopify/Globo ordering; no geometry-based margin compensation.
       Mixed Shopify/Globo fields keep their complete native rows; visual order is
       handled only by flow ranks and spacing only by the fixed rhythm rules. */
    optionUIEnabled() {
      return this.config.optionButtons !== false && this.config.compactOptions !== false;
    }
    optionKind(label) {
      const value = String(label || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase().replace(/\u0131/g, 'i').replace(/[\u00a0\u202f]/g, ' ')
        .replace(/[_:/|\-]+/g, ' ').replace(/\*/g, '').replace(/\s+/g, ' ').trim();
      // Live Prestige/Globo labels may include the currently selected value inside the
      // same label node (for example "GOLD COLOR 14K Yellow Gold"). Classify from
      // the leading semantic label instead of requiring the whole text to match.
      if (/^(?:gold colou?r|altin rengi|altin renk|metal colou?r|metal rengi|gold)(?:\s|$)/.test(value)) return 'metal';
      if (/^(?:precious stone|degerli tas|gem stone|gemstone|stone|tas)(?:\s|$)/.test(value) && !/^(?:stone|tas)\s+(?:weight|agirligi|carat|karat)(?:\s|$)/.test(value)) return 'stone';
      if (/^(?:single pair|singlepair|single or pair|pair single|single & pair|single and pair|tek cift|tek veya cift)(?:\s|$)/.test(value)) return 'singlepair';
      if (/^(?:ring size|yuzuk olcusu|bracelet size|bilezik olcusu|bileklik olcusu|size|beden|olcu|numara)(?:\s|$)/.test(value)) return 'size';
      if (/^(?:length|uzunluk)(?:\s|$)/.test(value)) return 'length';
      return ''; // Never infer Size from numeric choices, or Gold Color from "option1".
    }
    // V4.9.2: a shared CSS layout for the REAL native and app fields.
    // Do not reparent fields, clone app widgets, rename inputs, alter form ownership,
    // change option positions, or collapse distinct fields with the same caption.
    // Only non-interactive ancestor boxes are flattened; their DOM stays intact.
    restoreOrderNode(node, saved) {
      if (!saved) return;
      for (const name of saved.classes) node.classList.remove(name);
      if (saved.order) node.style.setProperty('--foen-flow-order', saved.order, saved.priority);
      else node.style.removeProperty('--foen-flow-order');
      if (!saved.hadStyle && !node.style.length) node.removeAttribute('style');
      if (saved.kind === null) node.removeAttribute('data-foen-flow-kind');
      else node.setAttribute('data-foen-flow-kind', saved.kind);
      this.orderPatches.delete(node);
    }
    restoreOptionOrder() {
      this.restoreFixedSpacing();
      for (const [node, saved] of this.orderPatches || []) this.restoreOrderNode(node, saved);
      this.orderPatches = new Map();
      this.orderVisibilityDirty?.clear();
      this.orderRoot = null;
      this.orderedLeaves = [];
      this.orderDeferred = false;
    }
    optionPickerOpen() {
      if (!this.info) return false;
      if (Date.now() < this.optionPointerGuardUntil) return true;
      if (CSS.supports('selector(select:open)')) {
        if (this.info.querySelector('select:open')) return true;
      } else if (document.activeElement?.matches('select') && this.info.contains(document.activeElement)) {
        // On older engines the platform picker has no queryable open state.
        // Wait for blur rather than dismissing an active system picker.
        return true;
      }
      return Boolean(this.info.querySelector('button.select[aria-expanded="true"],[role="combobox"][aria-expanded="true"],.nice-select.open'));
    }
    reconcileOptionOrder(plan) {
      // A refresh must NOT remove/reapply display:contents on unchanged ancestors.
      // That destroys Chromium's native popup even if the final layout is identical.
      for (const [node, saved] of this.orderPatches) {
        const desired = plan.get(node);
        if (!desired || (saved.layoutClasses && saved.layoutClasses.some(name => !desired.classes.includes(name)))) {
          this.restoreOrderNode(node, saved);
        }
      }
      for (const [node, desired] of plan) {
        desired.classes.forEach(name => this.rememberOrderNode(node, name, desired.order, desired.kind));
        this.orderPatches.get(node).layoutClasses = desired.classes;
      }
    }
    checkOrderVisibilityChanges() {
      // Only an actual external change requires checking original ancestor visibility.
      // Run after a picker closes; never tear down every bridge for ordinary refreshes.
      const dirty = [...this.orderVisibilityDirty];
      this.orderVisibilityDirty.clear();
      if (!dirty.length) return;
      for (const [node, saved] of this.orderPatches) {
        if (!(saved.layoutClasses || []).some(name => name === 'foen-order-bridge' || name === 'foen-order-root')) continue;
        if (dirty.some(changed => changed === node || changed.contains(node))) this.restoreOrderNode(node, saved);
      }
    }
    rememberOrderNode(node, className, order = null, kind = null) {
      let saved = this.orderPatches.get(node);
      if (!saved) {
        saved = { classes: [], order: node.style.getPropertyValue('--foen-flow-order'),
          priority: node.style.getPropertyPriority('--foen-flow-order'), hadStyle: node.hasAttribute('style'),
          kind: node.getAttribute('data-foen-flow-kind') };
        this.orderPatches.set(node, saved);
      }
      if (!node.classList.contains(className)) {
        saved.classes.push(className); node.classList.add(className);
      }
      if (order !== null && node.style.getPropertyValue('--foen-flow-order') !== String(order)) {
        node.style.setProperty('--foen-flow-order', String(order));
      }
      if (kind && node.getAttribute('data-foen-flow-kind') !== kind) node.setAttribute('data-foen-flow-kind', kind);
    }
    orderFieldKind(row) {
      const labels = row.matches('.variant-picker__option')
        ? ['.variant-picker__option-info legend', 'legend', '.variant-picker__option-info > label']
        : ['.gpo-label .label-content', '.gpo-label', '.option-label', '[data-label]', 'legend', 'label[for]'];
      for (const selector of labels) {
        const node = row.querySelector(selector);
        if (!node) continue;
        const clean = node.cloneNode(true);
        clean.querySelectorAll('input,select,textarea,button,a,.gpo-asterisk,.required,.foen-duplicate-option-value').forEach(el => el.remove());
        const kind = this.optionKind(clean.textContent.replace(/\*+/g, '').trim());
        if (kind) return kind;
      }
      for (const input of row.querySelectorAll('select,input[type="radio"]')) {
        const property = input.name.match(/^properties\[(.+)\]$/)?.[1];
        const kind = this.optionKind(property || input.getAttribute('aria-label') || '');
        if (kind) return kind;
      }
      return '';
    }
    orderNodeVisible(node, boundary) {
      for (let current = node; current instanceof Element; current = current.parentElement) {
        if (current.hidden || current.hasAttribute('inert') || current.getAttribute('aria-hidden') === 'true') return false;
        const style = getComputedStyle(current);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
        if (current === boundary) return true;
      }
      return false;
    }
    applyOptionOrder() {
      if (this.optionPickerOpen()) { this.orderDeferred = true; return; }
      this.orderDeferred = false;
      if (this.config.optionOrder === false || !this.info || !this.mainButton || !CSS.supports('display', 'contents')) {
        this.restoreOptionOrder(); return;
      }
      this.checkOrderVisibilityChanges();
      const root = this.info.querySelector('.product-info__block-list');
      if (!root || !root.contains(this.mainButton) || !this.orderNodeVisible(root, this)) { this.restoreOptionOrder(); return; }
      const candidates = new Map();
      const add = row => {
        if (!row || !root.contains(row) || row.closest('dialog,[data-foen-sticky],[data-foen-purchase-support]')) return;
        const controls = [...row.querySelectorAll('select,input[type="radio"]')].filter(input =>
          !input.closest('[data-foen-option-group]') && input.name !== 'id' && input.name !== 'selling_plan');
        // Combined-listing anchors are real native options too; never remove them.
        if (!controls.length && !row.matches('.variant-picker__option')) return;
        if (controls.some(control => control.form && this.form && control.form !== this.form)) return;
        candidates.set(row, this.orderFieldKind(row));
      };
      root.querySelectorAll('variant-picker .variant-picker__option, .variant-picker .variant-picker__option').forEach(add);
      root.querySelectorAll('.gpo-element, .gpo-form__group').forEach(row => {
        // Only the closest complete app field, not its multi-field parent.
        if (!row.querySelector('.gpo-element,.gpo-form__group')) add(row);
      });
      root.querySelectorAll('select[name^="properties["]').forEach(input => {
        if ([...candidates.keys()].some(row => row.contains(input))) return;
        const row = input.closest('.gpo-element,.gpo-form__group,.product-info__block-item') || input.parentElement;
        if (row && row.querySelectorAll('select').length === 1 && !row.querySelector('buy-buttons,form')) add(row);
      });
      if (![...candidates.values()].some(kind => ['metal','stone','singlepair','size'].includes(kind))) { this.restoreOptionOrder(); return; }
      const bridges = new Set();
      const rows = new Map();
      const pathFor = leaf => {
        const path = [];
        const unsafe = /^(?:LABEL|FIELDSET|LEGEND|SELECT|OPTION|BUTTON|A|INPUT|TEXTAREA|DETAILS|SUMMARY|DIALOG|TABLE|THEAD|TBODY|TR|TD|TH)$/;
        for (let parent = leaf.parentElement; parent && parent !== root; parent = parent.parentElement) {
          // Shopify and Globo can add passive custom-element wrappers around their
          // real field rows. Allow those wrappers to become display:contents so all
          // complete rows share one flex ordering context. Interactive/semantic
          // containers remain untouched, so form ownership and picker behaviour stay native.
          const passiveCustom = parent.tagName.includes('-') && !parent.matches('x-popover,x-drawer,popover-content');
          const passiveHtml = ['DIV','SPAN','FORM','SECTION'].includes(parent.tagName);
          if (unsafe.test(parent.tagName) || (!passiveHtml && !passiveCustom) ||
              parent.hasAttribute('tabindex') || parent.isContentEditable ||
              parent.matches('[onclick],[onpointerdown],[onmousedown]') ||
              (parent.hasAttribute('role') && !['group','presentation','none'].includes(parent.getAttribute('role')))) return null;
          path.push(parent);
        }
        return path;
      };
      for (const [row, kind] of candidates) {
        if (!this.orderNodeVisible(row, root)) continue;
        const path = pathFor(row);
        if (!path) continue;
        rows.set(row, kind); path.forEach(parent => bridges.add(parent));
      }
      if (!rows.size) { this.restoreOptionOrder(); return; }
      // V4.9.9: the real submit button is the ONLY purchase spacing owner.
      // Flatten its passive ancestors as part of the same visual order. Forms,
      // values, event delegation and fieldset semantics stay in their DOM tree.
      const purchaseLeaf = this.mainButton;
      const purchasePath = pathFor(purchaseLeaf);
      if (!purchasePath) { this.restoreOptionOrder(); return; }
      purchasePath.forEach(parent => bridges.add(parent));
      // Rows must remain complete boxes, even if a third-party wrapper is nested.
      for (const row of rows.keys()) bridges.delete(row);
      const leaves = [];
      const project = parent => {
        for (const child of parent.children) {
          if (child.matches('script,style,template,noscript,input[type="hidden"],link,meta')) continue;
          if (bridges.has(child)) project(child);
          else leaves.push(child);
        }
      };
      project(root);
      if ([...rows.keys()].some(row => !leaves.includes(row))) { this.restoreOptionOrder(); return; }
      const firstField = [...rows.keys()].sort((a,b) => a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1)[0];
      const before = (a,b) => Boolean(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
      const ranks = { metal:1000, stone:2000, singlepair:3000, size:4000, length:5000 };
      const plan = new Map();
      const planNode = (node, className, order = null, kind = null) => {
        const item = plan.get(node) || { classes: [], order: null, kind: null };
        if (!item.classes.includes(className)) item.classes.push(className);
        if (order !== null) item.order = order;
        if (kind !== null) item.kind = kind;
        plan.set(node, item);
      };
      const orderedLeaves = [];
      planNode(root, 'foen-order-root');
      bridges.forEach(parent => planNode(parent, 'foen-order-bridge'));
      leaves.forEach((leaf, index) => {
        let rank, kind = rows.get(leaf);
        const type = leaf.dataset.blockType || '';
        if (rows.has(leaf)) rank = ranks[kind] || 5500;
        else if (leaf === purchaseLeaf) { rank = 8000; kind = 'purchase'; }
        else if (leaf.matches('[data-foen-purchase-support]')) { rank = 9000; kind = 'support'; }
        else if (['title','price','vendor','rating','sku','badges'].includes(type) || before(leaf, firstField)) rank = 100;
        else rank = before(leaf, purchaseLeaf) ? 6500 : 10000;
        planNode(leaf, 'foen-order-item', rank + index, kind || 'other');
        if (rows.has(leaf)) planNode(leaf, 'foen-order-field');
        orderedLeaves.push({ node:leaf, rank:rank + index });
      });
      this.reconcileOptionOrder(plan);
      this.orderRoot = root;
      this.orderedLeaves = orderedLeaves.sort((a,b) => a.rank - b.rank);
      this.normalizeFixedSpacing();
    }
    onOrderTab(event) {
      // CSS reading-flow is progressive: some browsers still tab by form subtree.
      // Handle Tab transitions crossing/inside this root in both old and new browsers.
      // No positive tabindex, no focus stealing, no change to modal focus traps.
      if (event.key !== 'Tab' || event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey ||
          !this.orderRoot?.isConnected || this.overlayOpen()) return;
      const selector = 'a[href],area[href],button,input,select,textarea,summary,iframe,[tabindex],[contenteditable="true"]';
      const all = [...document.querySelectorAll(selector)].filter(node => {
        if (node.tabIndex < 0 || node.matches(':disabled') || node.closest('[hidden],[inert],dialog:not([open]),.foen-native-source-hidden')) return false;
        if (!node.getClientRects().length || getComputedStyle(node).visibility === 'hidden') return false;
        return true;
      }).filter((node, index, nodes) => {
        if (!node.matches('input[type="radio"]') || !node.name) return true;
        const group = nodes.filter(other => other.matches('input[type="radio"]') && other.name === node.name && other.form === node.form);
        return node === (group.find(other => other.checked) || group[0]);
      });
      // Respect an application's explicit positive tab order instead of overriding it.
      if (all.some(node => node.tabIndex > 0)) return;
      const inside = all.filter(node => this.orderRoot.contains(node));
      if (!inside.length) return;
      const ordered = this.orderedLeaves.flatMap(leaf => inside.filter(node => node === leaf.node || leaf.node.contains(node)));
      if (ordered.length !== inside.length) return;
      const first = all.indexOf(inside[0]);
      const flow = [...all.slice(0, first), ...ordered, ...all.slice(first).filter(node => !this.orderRoot.contains(node))];
      const current = document.activeElement;
      const index = flow.indexOf(current);
      if (index < 0) return;
      const target = flow[index + (event.shiftKey ? -1 : 1)];
      if (!target || (!this.orderRoot.contains(current) && !this.orderRoot.contains(target))) return;
      event.preventDefault(); target.focus();
    }

    optionCaption(label) {
      const original = String(label || '').trim();
      const detailed = original.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\u0131/g, 'i').replace(/[:*]+/g, '').trim();
      if (/^(degerli tas|yuzuk olcusu|bilezik olcusu|bileklik olcusu|bracelet size)$/.test(detailed)) return original;
      const kind = this.optionKind(label);
      const tr = /^tr(?:-|$)/i.test(this.config.locale || '');
      const captions = {
        metal: tr ? 'Alt\u0131n rengi' : 'Gold Color',
        stone: this.config.strings.stone || (tr ? 'Ta\u015f' : 'Stone'),
        size: this.config.strings.size || (tr ? '\u00d6l\u00e7\u00fc' : 'Size'),
        singlepair: tr ? 'Tek / \u00c7ift' : 'Single / Pair',
        length: tr ? 'Uzunluk' : 'Length'
      };
      return captions[kind] || String(label || '').trim();
    }
    localizeCaption(node) {
      // Modify only an unambiguous, text-only caption, not labels/options/required markers.
      if (!node || node.children.length || !node.textContent.trim()) return;
      if (!this.captionStates) this.captionStates = new Map();
      const old = this.captionStates.get(node);
      const original = old && node.textContent === old.rendered ? old.original : node.textContent;
      const caption = this.optionCaption(original);
      if (!this.optionKind(original) || caption === original) return;
      if (node.textContent !== caption) node.textContent = caption;
      this.captionStates.set(node, { original, rendered: caption });
    }
    hideDuplicateOptionValues() {
      if (!this.info || !this.optionUIEnabled()) return;
      if (!this.duplicateCaptions) this.duplicateCaptions = new Set();
      for (const node of this.duplicateCaptions) {
        if (!node.isConnected) this.duplicateCaptions.delete(node);
      }
      // Only the native display-only selected-value span alongside a legend qualifies.
      // label[for], anchors, live inputs, app captions and help text never qualify.
      this.info.querySelectorAll('variant-picker .variant-picker__option').forEach(fieldset => {
        const legend = fieldset.querySelector('.variant-picker__option-info legend');
        if (!legend) return;
        const header = legend.parentElement;
        const input = fieldset.querySelector('input[type="radio"]:checked');
        const selected = input?.labels?.[0]?.textContent?.trim();
        if (!selected) return;
        [...header.children].forEach(node => {
          if (!node.matches('span') || node.children.length || node.hasAttribute('role') ||
              node.hasAttribute('aria-live') || node.hasAttribute('tabindex') ||
              node.classList.contains('sr-only') || node.closest('label,button,a,dialog,x-modal,x-popover')) return;
          if (node.textContent.trim() === selected) {
            node.classList.add('foen-duplicate-option-value'); this.duplicateCaptions.add(node);
          }
        });
      });
    }
    restoreOptionSource(group) {
      group?.listenerController?.abort();
      group?.source?.classList.remove('foen-native-source-hidden');
    }
    teardownOptions() {
      this.optionGroups?.forEach((group, rail) => { this.restoreOptionSource(group); rail.remove(); });
      this.optionGroups?.clear();
      this.duplicateCaptions?.forEach(node => node.classList.remove('foen-duplicate-option-value'));
      this.duplicateCaptions?.clear();
      this.captionStates?.forEach((state, node) => {
        if (node.textContent === state.rendered) node.textContent = state.original;
      });
      this.captionStates?.clear();
      this.removeAttribute('data-foen-options-active');
    }
    nativeOptionDescriptor(fieldset) {
      if (!this.form || !fieldset.closest('variant-picker') || fieldset.closest('.gpo-element,.gpo-form__group')) return null;
      // Only known Prestige radio groups can receive a display-only selector.
      // Links (combined listings), required groups, unknown widgets and native selects remain native.
      let source = fieldset.querySelector('.variant-picker__option-values');
      if (!source) {
        const trigger = fieldset.querySelector('button.select[aria-controls]');
        const popover = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
        if (popover && trigger.parentElement?.contains(popover)) source = trigger.parentElement;
      }
      if (!source || source.closest('[hidden]') || source.hasAttribute('inert')) return null;
      if (source.querySelector('a[href], select, textarea, input:not([type="radio"]), button:not(.select), .gpo-element, .gpo-form__group, [contenteditable="true"], iframe')) return null;
      const inputs = [...source.querySelectorAll('input[type="radio"]')];
      if (!inputs.length || inputs.length > 100 || !inputs.some(input => input.checked)) return null;
      const name = inputs[0].name, position = inputs[0].dataset.optionPosition;
      if (!name || !position || inputs.some(input => input.name !== name || input.form !== this.form ||
          input.dataset.optionPosition !== position || input.required || input.validity.customError || input.dataset.productUrl)) return null;
      const choices = inputs.map(input => ({ input, value: input.value, text: (input.labels?.[0]?.textContent || '').trim() }));
      if (choices.some(choice => !choice.text || choice.text.length > 120) || new Set(choices.map(choice => choice.value)).size !== choices.length) return null;
      const legend = fieldset.querySelector('.variant-picker__option-info legend,legend');
      const label = this.optionCaption(legend?.textContent || '');
      return { fieldset, source, choices, label, position };
    }
    enhanceOptions() {
      if (!this.info || !this.optionUIEnabled()) { this.teardownOptions(); return; }
      this.setAttribute('data-foen-options-active', '');
      this.captionStates?.forEach((_, node) => { if (!node.isConnected) this.captionStates.delete(node); });
      // Cleanup obsolete native proxies without touching app fields or their ancestors.
      for (const [rail, group] of this.optionGroups) {
        const current = group.fieldset.isConnected && this.nativeOptionDescriptor(group.fieldset);
        if (!rail.isConnected || !current || current.source !== group.source ||
            current.choices.length !== group.choices.length || current.choices.some((choice, index) =>
              choice.input !== group.choices[index].input || choice.value !== group.choices[index].value || choice.text !== group.choices[index].text)) {
          const hadFocus = rail.contains(document.activeElement);
          this.restoreOptionSource(group); rail.remove(); this.optionGroups.delete(rail);
          if (hadFocus && group.source.isConnected) {
            const control = group.source.querySelector('button:not(:disabled),input:checked:not(:disabled),input:not(:disabled)');
            control?.focus({ preventScroll: true });
          }
        }
      }
      this.info.querySelectorAll('variant-picker .variant-picker__option').forEach(fieldset => {
        this.localizeCaption(fieldset.querySelector('.variant-picker__option-info legend,legend'));
        const descriptor = this.nativeOptionDescriptor(fieldset);
        if (!descriptor) return;
        const existing = [...this.optionGroups.values()].find(group => group.source === descriptor.source);
        if (!existing) this.createNativeDropdown(descriptor);
      });
      // These are the application's OWN captions. No input or app wrapper is replaced.
      this.info.querySelectorAll('.gpo-element .gpo-label .label-content').forEach(node => this.localizeCaption(node));
      for (const [rail, group] of this.optionGroups) {
        if (!rail.isConnected) continue;
        const select = group.customSelect;
        const checked = group.choices.find(choice => choice.input.checked);
        const disabled = group.fieldset.matches(':disabled') || group.choices.every(choice => choice.input.matches(':disabled'));
        if (select.disabled !== disabled) select.disabled = disabled;
        [...select.options].forEach((option, index) => {
          const choice = group.choices[index];
          const unavailable = choice.input.matches(':disabled');
          if (option.disabled !== unavailable) option.disabled = unavailable;
        });
        const value = checked?.value || '';
        if (select.value !== value) select.value = value;
      }
      this.restoreOptionFocus();
    }
    createNativeDropdown(group) {
      const wrap = document.createElement('div');
      wrap.className = 'foen-variant-dropdown-wrap'; wrap.dataset.foenOptionGroup = '';
      const select = document.createElement('select');
      select.className = 'foen-variant-dropdown'; select.dataset.foenVariantDropdown = '';
      select.id = `FoenSelect-${this.dataset.formId}-${group.position}`.replace(/[^a-zA-Z0-9_-]/g, '-');
      select.setAttribute('aria-label', group.label || this.config.strings.size || 'Option');
      // No name/form: the original radios remain the ONLY submitted native option values.
      group.choices.forEach(choice => {
        const option = document.createElement('option'); option.value = choice.value;
        option.textContent = choice.text; option.disabled = choice.input.matches(':disabled');
        option.selected = choice.input.checked; select.append(option);
      });
      wrap.append(select); group.source.insertAdjacentElement('afterend', wrap);
      group.source.classList.add('foen-native-source-hidden');
      group.customSelect = select; group.rail = wrap;
      group.listenerController = new AbortController();
      this.optionGroups.set(wrap, group);
      select.addEventListener('change', event => {
        event.stopPropagation();
        const choice = group.choices.find(item => item.value === select.value);
        if (!group.source.isConnected || !choice?.input.isConnected || choice.input.matches(':disabled')) {
          this.scheduleRefresh(); return;
        }
        this.optionFocus = { id: select.id, node: select, time: Date.now() };
        if (!choice.input.checked) choice.input.click();
        this.scheduleRefresh();
      }, { signal: group.listenerController.signal });
    }
    restoreOptionFocus() {
      const saved = this.optionFocus;
      if (!saved || saved.node.isConnected || Date.now() - saved.time > 5000) return;
      if (document.activeElement !== document.body && document.activeElement !== document.documentElement) return;
      const select = document.getElementById(saved.id);
      if (select && this.contains(select) && !select.matches(':disabled') && select.getClientRects().length) {
        select.focus({ preventScroll: true });
        this.optionFocus = { id: select.id, node: select, time: Date.now() };
      }
    }
    hideLegacyFeedback() {
      // Never hide an entire merchant/app block because it contains a legacy status.
      this.querySelectorAll('[data-foen-status]:not([data-foen-status-v4])').forEach(status => { status.hidden = true; });
    }
    enhanceGallery() {
      const gallery = this.querySelector('.foen-gallery-shell product-gallery, .foen-gallery-shell .product-gallery');
      const carousel = gallery?.querySelector('scroll-carousel, media-carousel, .product-gallery__carousel');
      const tools = this.querySelector('[data-foen-gallery-tools]');
      if (!gallery || !carousel || !tools) return;
      if (carousel !== this.carousel || !this.galleryController) {
        this.galleryController?.abort(); this.galleryMutations?.disconnect();
        this.galleryController = new AbortController(); this.carousel = carousel;
        const signal = this.galleryController.signal;
        carousel.addEventListener('scroll', () => this.scheduleGallery(), { passive: true, signal });
        carousel.addEventListener('carousel:change', () => this.scheduleGallery(), { signal });
        carousel.addEventListener('carousel:select', () => this.scheduleGallery(), { signal });
        this.galleryMutations = new MutationObserver(() => this.scheduleGallery());
        this.galleryMutations.observe(carousel, { attributes: true, subtree: true, attributeFilter: ['hidden', 'class', 'style', 'aria-current'] });
      }
      this.tools = tools;
      if (!carousel.hasAttribute('data-foen-main-carousel')) carousel.setAttribute('data-foen-main-carousel', '');
      const direct = [...carousel.children].filter(el => el.matches('[data-media-id], .product-gallery__media'));
      this.slides = direct.length ? direct : [...carousel.querySelectorAll('.product-gallery__media[data-media-id]')];
      if (!this.slides.length) return; // Unrecognized theme structure: retain the native controls.
      tools.hidden = this.slides.length < 2;
      this.setAttribute('data-foen-gallery-ready', '');
      this.updateGallery();
    }
    scheduleGallery() {
      if (this.galleryFrame) return;
      this.galleryFrame = requestAnimationFrame(() => { this.galleryFrame = 0; if (this.isConnected) this.updateGallery(); });
    }
    visibleSlides() {
      return (this.slides || []).filter(el => !el.hidden && getComputedStyle(el).display !== 'none');
    }
    updateGallery() {
      if (!this.carousel?.isConnected || !this.tools) return;
      const slides = this.visibleSlides(); if (!slides.length) return;
      const frame = this.carousel.getBoundingClientRect();
      const horizontal = window.innerWidth < 1000 || this.carousel.scrollWidth > this.carousel.clientWidth + 5;
      let selected = slides[0];
      if (horizontal) {
        const center = frame.left + frame.width / 2;
        let distance = Infinity;
        for (const slide of slides) {
          const r = slide.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - center);
          if (d < distance) { distance = d; selected = slide; }
        }
      } else if (Number.isInteger(this.carousel.selectedIndex)) {
        selected = this.slides[this.carousel.selectedIndex] || selected;
      }
      this.currentSlide = selected;
      const index = Math.max(0, slides.indexOf(selected));
      const count = this.tools.querySelector('[data-foen-count]');
      const label = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      if (count && count.textContent !== label) count.textContent = label;
      this.tools.style.setProperty('--foen-progress', `${((index + 1) / slides.length) * 100}%`);
      const prev = this.tools.querySelector('[data-foen-prev]'); const next = this.tools.querySelector('[data-foen-next]');
      if (prev) prev.disabled = index === 0; if (next) next.disabled = index === slides.length - 1;
      const ids = new Set(slides.map(slide => slide.dataset.mediaId));
      this.tools.querySelectorAll('[data-foen-thumb]').forEach(button => {
        const id = button.dataset.foenThumb; button.hidden = !ids.has(id);
        const active = id === selected.dataset.mediaId;
        if (button.getAttribute('aria-current') !== String(active)) button.setAttribute('aria-current', String(active));
        if (active && this.lastActiveMedia !== id) {
          const rail = button.parentElement; const r = button.getBoundingClientRect(); const pr = rail.getBoundingClientRect();
          if (r.left < pr.left || r.right > pr.right) rail.scrollTo({ left: rail.scrollLeft + r.left - pr.left - 20, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
        }
      });
      this.lastActiveMedia = selected.dataset.mediaId;
    }
    selectMedia(id, instant = false) {
      const slide = this.visibleSlides().find(el => el.dataset.mediaId === id); if (!slide || !this.carousel) return false;
      if (window.innerWidth >= 1000 && this.carousel.scrollWidth <= this.carousel.clientWidth + 5 && getComputedStyle(this.carousel).overflowX === 'visible') {
        if (!instant) slide.scrollIntoView({ block: 'center', behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      } else if (typeof this.carousel.select === 'function') {
        // Maestrooo's own carousel still owns media/video/zoom state.
        const index = this.visibleSlides().indexOf(slide);
        try { this.carousel.select(index, { instant: instant || this.reducedMotion.matches }); } catch (_) { this.scrollToSlide(slide, instant); }
      } else {
        this.scrollToSlide(slide, instant);
      }
      this.scheduleGallery(); return true;
    }
    scrollToSlide(slide, instant) {
      const r = slide.getBoundingClientRect(); const cr = this.carousel.getBoundingClientRect();
      this.carousel.scrollTo({ left: this.carousel.scrollLeft + r.left - cr.left, behavior: instant || this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
    onClick(event) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('[data-foen-client-advisor]')) this.updateAdvisorLink();
      const serviceButton = event.target.closest('[data-foen-open-service]');
      if (serviceButton) {
        const dialog = [...this.querySelectorAll('[data-foen-service]')].find(el => el.dataset.foenService === serviceButton.dataset.foenOpenService);
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault(); this.serviceOpener = serviceButton;
          this.hideConfirmation(); dialog.showModal();
           const body = dialog.querySelector('.foen-service-body');
           if (body) body.scrollTop = 0;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden'; this.ownsScrollLock = true;
          this.scheduleSticky();
        }
        return;
      }
      if (event.target.closest('[data-foen-close-service]')) {
        event.target.closest('dialog')?.close(); return;
      }
      const thumb = event.target.closest('[data-foen-thumb]');
      if (thumb) { event.preventDefault(); this.selectMedia(thumb.dataset.foenThumb); return; }
      const previous = event.target.closest('[data-foen-prev]'); const next = event.target.closest('[data-foen-next]');
      if (previous || next) {
        const slides = this.visibleSlides(); const index = slides.indexOf(this.currentSlide);
        const target = slides[index + (next ? 1 : -1)]; if (target) this.selectMedia(target.dataset.mediaId); return;
      }
      if (event.target.closest('[data-foen-close-confirmation]')) { this.dismissConfirmation(); return; }
      if (event.target.closest('[data-foen-close-guide]')) { this.guide?.close(); return; }
      const guideLink = event.target.closest('[data-foen-open-guide]');
      if (guideLink && this.guide && typeof this.guide.showModal === 'function') {
        event.preventDefault(); this.guideOpener = guideLink;
        this.hideConfirmation(); this.guide.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden'; this.ownsScrollLock = true;
        this.scheduleSticky();
      }
    }
    onGuideClose() {
      this.restoreScroll();
      if (this.guideOpener?.isConnected) this.guideOpener.focus({ preventScroll: true });
      this.scheduleSticky();
    }
    restoreScroll() {
      if (this.ownsScrollLock) {
        if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = this.previousOverflow || '';
        this.ownsScrollLock = false;
      }
    }
    overlayOpen() {
      return Boolean(document.querySelector('dialog[open], cart-drawer[open], x-drawer[open], x-modal[open], .drawer[open], .modal[open], .pswp--open'));
    }
    scheduleSticky() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.isConnected) this.updateSticky(); });
    }
    updateSticky() {
      if (this.info) {
        const header = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-area-height')) || 80;
        this.info.classList.toggle('foen-info-too-tall', this.info.offsetHeight > window.innerHeight - header - 48);
      }
      if (!this.sticky || !this.mainButton) return;
      const overlay = this.overlayOpen();
      if (overlay) this.hideConfirmation(false);
      const rect = this.mainButton.getBoundingClientRect();
      const footerVisible = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
      const active = document.activeElement;
      const typing = active?.matches?.('textarea, select, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"])');
      const keyboard = window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
      const confirmationOpen = this.querySelector('[data-foen-confirmation]:not([hidden])');
      const show = Boolean(rect.bottom < 0 && !overlay && !footerVisible && !(typing && keyboard) && !confirmationOpen);
      this.sticky.hidden = !show;
    }
    statusElement() {
      let el = this.querySelector('[data-foen-status-v4]');
      if (!el && this.info) {
        el = document.createElement('div'); el.className = 'foen-status'; el.dataset.foenStatus = ''; el.dataset.foenStatusV4 = '';
        const block = this.mainButton?.closest('.product-info__block-item') || this.mainButton?.closest('buy-buttons');
        if (block) block.insertAdjacentElement('afterend', el); else this.info.append(el);
      }
      return el;
    }
    setStatus(text, state) {
      const el = this.statusElement(); if (!el) return;
      el.hidden = false; el.dataset.state = state;
      el.setAttribute('role', state === 'error' ? 'alert' : 'status');
      el.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
      el.setAttribute('aria-atomic', 'true');
      if (el.textContent !== text) el.textContent = text;
      if (state === 'uncertain') {
        const link = document.createElement('a'); link.href = this.config.cartUrl;
        link.textContent = this.config.strings.viewCart; link.className = 'foen-text-button';
        el.append(document.createTextNode(' '), link);
      }
    }
    cartRequestActive(form = this.form) {
      if (!form) return false;
      if (form.dataset.foenCartSubmitting === 'true' || form.closest('product-form')?._foenSubmitting === true) return true;
      if (form.dataset.foenVariantLoading === 'true') return false;
      return [...form.elements].some(element => element.type === 'submit' && element.getAttribute('aria-busy') === 'true');
    }
    onSubmit(event) {
      if (!this.form || event.target !== this.form || event.defaultPrevented) return;
      // The owner of the network request owns the submission lock. A candidate or a
      // stale UI timeout must never block an app's corrected validation/retry.
      if (this.cartRequestActive()) {
        event.preventDefault(); event.stopImmediatePropagation(); return;
      }
      const form = this.form;
      const id = form.elements.namedItem('id');
      const variantId = String(id?.value || '');
      if (!variantId || id.disabled || form.dataset.foenVariantLoading === 'true') return;
      const rawQuantity = Number(form.elements.namedItem('quantity')?.value || 1);
      const quantity = Number.isFinite(rawQuantity) && rawQuantity > 0 ? rawQuantity : 1;
      // Do not construct FormData here: apps may subscribe to its formdata event.
      const attempt = { form, variantId, quantity, time: Date.now(), token: Symbol('request'), started: false };
      this.pending = attempt;
      // A task (not a microtask) is required: browser-originated events can run
      // microtask checkpoints between capture and target listeners.
      this.later(() => {
        if (!this.isConnected || this.pending !== attempt) return;
        if (!this.cartRequestActive(form)) {
          this.pending = null; // Validation cancelled or normal navigation: leave native behavior alone.
          const status = this.querySelector('[data-foen-status-v4]');
          if (status?.dataset.state === 'pending') status.hidden = true;
          return;
        }
        attempt.started = true;
        this.lastConfirmationToken = null;
        this.querySelectorAll('[data-foen-added]').forEach(button => button.removeAttribute('data-foen-added'));
        this.hideConfirmation(); this.setStatus(this.config.strings.adding, 'pending');
        this.later(() => {
          if (this.pending !== attempt) return;
          attempt.timedOut = true;
          this.setStatus(this.config.strings.uncertain, 'uncertain');
          // Keep the event association for a late success. Never retry cart/add here.
        }, 20000);
      }, 0);
    }
    onAdded(event) {
      if (!this.pending) return;
      const origin = event.target instanceof Element ? event.target.closest('form') : null;
      if (origin !== this.form) return;
      const items = Array.isArray(event.detail?.items) ? event.detail.items : [];
      const item = items.find(entry => String(entry.variant_id ?? entry.id) === this.pending.variantId);
      if (!item) return;
      const request = this.pending; this.pending = null;
      this.lastConfirmationToken = request.token;
      this.setStatus(this.config.strings.added, 'success');
      this.later(() => {
        const status = this.querySelector('[data-foen-status-v4]');
        if (this.lastConfirmationToken === request.token && status?.dataset.state === 'success') status.hidden = true;
      }, 4500);
      [...this.querySelectorAll('buy-buttons button[type="submit"], .buy-buttons button[type="submit"]')].filter(button => button.form === this.form).forEach(button => {
        button.dataset.foenAdded = this.config.strings.added;
        this.later(() => button.removeAttribute('data-foen-added'), 1800);
      });
      if (!this.config.confirmation) return;
      this.later(() => {
        if (!this.pending && this.lastConfirmationToken === request.token && !this.overlayOpen()) this.showConfirmation(item, request.quantity);
      }, 300);
    }
    onCartError(event) {
      if (!this.pending) return;
      const origin = event.target instanceof Element ? event.target.closest('form') : null;
      if (origin !== this.form) return;
      this.pending = null;
      this.lastConfirmationToken = null;
      this.querySelectorAll('[data-foen-added]').forEach(button => button.removeAttribute('data-foen-added'));
      const error = event.detail?.error;
      const text = typeof error === 'string' ? error : (error?.description || error?.message || this.config.strings.error);
      this.hideConfirmation(); this.setStatus(text, event.detail?.uncertain || event.detail?.added ? 'uncertain' : 'error');
    }
    showConfirmation(item, quantity) {
      const panel = this.querySelector('[data-foen-confirmation]'); if (!panel) return;
      panel.querySelector('[data-foen-confirm-title]').textContent = item.product_title || item.title || this.config.title;
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      panel.querySelector('[data-foen-confirm-variant]').textContent = [variant, `${this.config.strings.quantity}: ${quantity}`].filter(Boolean).join(' \u00b7 ');
      const price = panel.querySelector('[data-foen-confirm-price]');
      const amount = item.final_price ?? item.price;
      if (price) {
        price.hidden = true;
        if (Number.isFinite(Number(amount)) && amount !== null && amount !== undefined) {
          try {
            price.textContent = new Intl.NumberFormat(this.config.locale || 'en', { style: 'currency', currency: this.config.currency || 'TRY' }).format(Number(amount) / 100);
            price.hidden = false;
            this.normalizePrices();
          } catch (_) { /* Price formatting must never block confirmation. */ }
        }
      }
      const image = panel.querySelector('[data-foen-confirm-image]');
      const imageSource = item.featured_image?.url || item.image || this.config.image;
      image.hidden = true;
      if (imageSource) {
        try {
          const url = new URL(imageSource, document.baseURI);
          if (['https:', 'http:'].includes(url.protocol)) {
            image.src = url.href; image.alt = item.product_title || this.config.title; image.hidden = false;
          }
        } catch (_) { /* A missing thumbnail does not block confirmation. */ }
      }
      panel.hidden = false; this.scheduleSticky();
    }
    dismissConfirmation() {
      const panel = this.querySelector('[data-foen-confirmation]');
      const restoreFocus = panel && !panel.hidden && panel.contains(document.activeElement);
      this.hideConfirmation();
      if (restoreFocus && this.mainButton?.isConnected) this.mainButton.focus({ preventScroll: true });
    }
    hideConfirmation(schedule = true) {
      const panel = this.querySelector('[data-foen-confirmation]'); if (panel) panel.hidden = true;
      if (schedule) this.scheduleSticky();
    }
    // Move original theme blocks, not cloned forms. All nodes stay inside the same
    // product-rerender boundary, so IDs, events and theme-editor attributes survive.
    relocateNarrative() {
      if (!this.info) return;
      const content = this.querySelector('[data-foen-content-column]');
      const extra = content?.querySelector('[data-foen-extra-slot]');
      if (!extra) return;
      const keyFor = node => {
        if(node.dataset.blockId) return node.dataset.blockId;
        try {return JSON.parse(node.getAttribute('data-shopify-editor-block') || '{}').id || '';} catch(_) {return '';}
      };
      for(const block of [...this.info.querySelectorAll('.product-info__block-item')]) {
        if(block.querySelector('form,input,select,textarea,buy-buttons,variant-picker')) continue;
        const type=(block.dataset.blockType || '').replace(/-/g,'_');
        if(type==='description' && this.querySelector('[data-foen-product-copy]')) {
          // The full product description now has one visible server-rendered home after the trust rail.
          // Retain the native wrapper for Prestige's partial rerender matching, but never display it twice.
          block.classList.add('foen-retired-block');
          continue;
        }
        const legacyAdvisor = block.querySelector('.foen-advisor,[data-foen-advisor],.foen-client-advisor');
        const legacyChat = [...block.querySelectorAll('a[href]')].find(link => {
          if(link.hasAttribute('data-foen-client-advisor') || link.hasAttribute('data-foen-store')) return false;
          return /(?:wa\.me|api\.whatsapp\.com)/i.test(link.getAttribute('href') || '') && /foen\s*(?:advisor|dan[i\u0131][s\u015f]man)|contact a client advisor/i.test(link.textContent || '');
        });
        if(legacyAdvisor || legacyChat) { block.classList.add('foen-retired-block'); continue; }
        if(!['text','disclosures','complementary_products','accordion'].includes(type)) continue;
        if(extra.contains(block)) continue;
        const key=keyFor(block);
        if(key) {
          [...extra.querySelectorAll('.product-info__block-item')].forEach(old=>{if(old!==block && keyFor(old)===key) old.remove();});
          block.dataset.foenRelocated=key;
        }
        extra.append(block);
      }
      const order=this.config.narrativeOrder || [];
      const sorted=[...extra.children].sort((a,b)=>{
        const ai=order.indexOf(keyFor(a)),bi=order.indexOf(keyFor(b));
        return (ai<0?10000:ai)-(bi<0?10000:bi);
      });
      sorted.forEach((node,index)=>{if(extra.children[index]!==node) extra.insertBefore(node,extra.children[index] || null);});
      extra.hidden=!extra.textContent.trim() && !extra.querySelector('img,video,iframe');
      const policies=content.querySelector('[data-foen-policy-accordions]');
      if(policies) policies.hidden=!policies.querySelector('details');
      content.hidden=Boolean((!policies || policies.hidden) && extra.hidden);
      const column=this.querySelector('[data-foen-purchase-column]');
      if(this.info.querySelector('.foen-size-guide-trigger')) column?.setAttribute('data-foen-inline-guide','');
      else column?.removeAttribute('data-foen-inline-guide');
    }

    updateMadeToOrder() {
      const item=this.querySelector('[data-foen-made-to-order]');
      const standard=this.querySelector('[data-foen-standard]');
      if(!item || !standard) return;
      const config=this.config.madeToOrder || {};
      const normalize=value=>String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\u0131/g,'i').replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();
      // FOEN Gold Color has only these six locale values:
      // EN: 14K Yellow Gold / 14K White Gold / 14K Rose Gold
      // TR: 14K Sarı Altın / 14K Beyaz Altın / 14K Rose Altın
      const goldMetalToken=value=>{
        const match=normalize(value).match(/\b14k (yellow gold|sari altin|white gold|beyaz altin|rose gold|rose altin)\b/);
        return match ? `14k ${match[1]}` : '';
      };
      const isMadeToOrderMetal=value=>/^(?:14k white gold|14k beyaz altin|14k rose gold|14k rose altin)$/.test(goldMetalToken(value));
      const isMetalName=value=>this.optionKind?.(value)==='metal' || /^(?:select ?1|option ?1|gold colou?r|material|materyal|metal(?: color| colour| rengi)?|color|colour|renk|altin rengi|altin renk)$/.test(normalize(value));
      const addValue=(list,value)=>{
        const clean=String(value || '').trim();
        if(clean && !list.includes(clean)) list.push(clean);
      };
      const readControl=(control,list)=>{
        if(!control || control.matches?.(':disabled')) return;
        if(control instanceof HTMLSelectElement) {
          addValue(list,control.selectedOptions?.[0]?.textContent);
          addValue(list,control.value);
          return;
        }
        if(control instanceof HTMLInputElement && ['radio','checkbox'].includes(control.type) && !control.checked) return;
        addValue(list,control.value);
        addValue(list,control.getAttribute?.('data-value'));
        addValue(list,control.getAttribute?.('aria-label'));
        if(control instanceof HTMLInputElement && control.labels?.length) control.labels.forEach(label=>addValue(list,label.textContent));
      };
      let visible=config.mode==='always' || config.override===true || config.tagged===true;
      if(config.mode==='auto' && !visible) {
        const info=this.info || this.querySelector('.product-info');
        const propertyValues=[];
        const metalValues=[];
        const roots=[info,this.form].filter((root,index,array)=>root && array.indexOf(root)===index);

        // Globo and similar option apps often keep the selected value in a hidden
        // line-item property. Read that canonical value even when the visible picker
        // is a custom button instead of a native select.
        roots.forEach(root=>{
          root.querySelectorAll('select[name^="properties["],input[name^="properties["]').forEach(control=>{
            if(control.name==='id' || control.name==='selling_plan') return;
            if(control.form && this.form && control.form!==this.form) return;
            const property=control.name.match(/^properties\[(.+)\]$/)?.[1];
            if(!property || !isMetalName(property)) return;
            readControl(control,propertyValues);
          });
        });

        // Read only rows that are actually the Metal / Gold Color field. This avoids
        // Stone and Size values masking the selected metal, while supporting both
        // Shopify's native variant picker and Globo's app field wrappers.
        info?.querySelectorAll('.variant-picker__option,.gpo-element,.gpo-form__group').forEach(row=>{
          if(this.orderFieldKind(row)!=='metal') return;
          row.querySelectorAll('select,input').forEach(control=>readControl(control,metalValues));
          row.querySelectorAll('button.select,[role="combobox"]').forEach(control=>{
            addValue(metalValues,control.getAttribute('data-value'));
            addValue(metalValues,control.getAttribute('aria-label'));
            addValue(metalValues,control.textContent);
          });
          row.querySelectorAll('[role="option"][aria-selected="true"],[aria-pressed="true"]').forEach(control=>{
            addValue(metalValues,control.getAttribute('data-value'));
            addValue(metalValues,control.textContent);
          });
        });

        // App property wins when present; otherwise use the identified metal row.
        // Only if neither exists do we fall back to the current Shopify variant.
        const values=propertyValues.length ? propertyValues : metalValues.length ? metalValues : this.currentVariant?.options || [];
        visible=values.length ? values.some(isMadeToOrderMetal) : Boolean(config.initial);
      }
      if(config.mode==='never' || config.override===false) visible=false;
      item.hidden=!visible;
      standard.hidden=![...standard.querySelectorAll('.foen-standard-item')].some(row=>!row.hidden);
    }

    polishPurchaseHeader() {
      if (!this.info) return;
      const title = this.info.querySelector('.product-info__block-item[data-block-type="title"]');
      const price = this.info.querySelector('.product-info__block-item[data-block-type="price"]');
      if (!title || !price) return;
      title.classList.add('foen-title-block');
      price.classList.add('foen-price-block');
      const heading = title.querySelector('h1,h2,h3,h4,h5,h6,.product-title');
      heading?.classList.add('foen-title-text');

      // Normalize only decoration on the path to the real text/price.
      // Tax notices, sale prices, ratings and controls keep their original nodes.
      const normalizeInner = (leaf, root) => {
        for (let node = leaf?.parentElement; node && node !== root; node = node.parentElement) {
          if (node.querySelector('form,input,select,textarea,button,variant-picker')) break;
          node.classList.add('foen-header-inner');
        }
      };
      normalizeInner(heading, title);
      normalizeInner(price.querySelector('sale-price') || price.querySelector('price-list,.price-list'), price);

      let common = title.parentElement;
      while (common && common !== this.info && !common.contains(price)) common = common.parentElement;
      if (!common || common === this.info) return;
      const branchBelow = (node, parent) => {
        while (node.parentElement && node.parentElement !== parent) node = node.parentElement;
        return node;
      };
      const titleRoot = branchBelow(title, common);
      const priceRoot = branchBelow(price, common);
      if (titleRoot === priceRoot) return;
      const blocks = [...common.querySelectorAll('.product-info__block-item')];
      const headerTypes = new Set(['title','price','vendor','rating','sku','badges']);
      const onlyHeader = blocks.every(block =>
        headerTypes.has(block.dataset.blockType) || block.classList.contains('foen-retired-block')
      );
      if (onlyHeader) common.classList.add('foen-heading-stack');

      const markBranch = leaf => {
        for (let node = leaf.parentElement; node && node !== common; node = node.parentElement) {
          const nested = [...node.querySelectorAll('.product-info__block-item')];
          if (nested.some(block => block !== leaf && !block.classList.contains('foen-retired-block'))) break;
          node.classList.add('foen-header-branch');
        }
      };
      markBranch(title);
      markBranch(price);
      if (priceRoot !== price && priceRoot.classList.contains('foen-header-branch')) {
        priceRoot.classList.add('foen-header-price-root');
      }
    }

    updateAdvisorLink() {
      const link = this.querySelector('[data-foen-client-advisor]');
      const config = this.config.advisor || {};
      if (!link || !config.url) return;
      try {
        const url = new URL(config.url, document.baseURI);
        const supported = url.protocol === 'https:' && (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com' || url.hostname === 'web.whatsapp.com');
        if (!supported) { link.hidden = true; return; }
        link.hidden = false;
        // Business short links are opaque; retain their destination. For per-language
        // drafts use a direct wa.me/<number> or api.whatsapp.com/send?phone=... link.
        if (!url.pathname.startsWith('/message/')) {
          const message = [String(config.message || '').trim() || url.searchParams.get('text') || ''].filter(Boolean);
          // This switch controls only the product appendix, not the localized introduction.
          if (config.includeProduct !== false) {
            if (this.config.title) message.push(this.config.title);
            if (config.productUrl) {
              const productUrl = new URL(config.productUrl, document.baseURI);
              if (['https:', 'http:'].includes(productUrl.protocol)) {
                const variant = this.form?.elements.namedItem('id')?.value;
                if (variant && /^\d+$/.test(variant)) productUrl.searchParams.set('variant', variant);
                message.push(productUrl.href);
              }
            }
          }
          if (message.length) url.searchParams.set('text', message.join('\n'));
          else url.searchParams.delete('text');
        }
        if (link.href !== url.href) link.href = url.href;
      } catch (_) { link.hidden = true; }
    }

    rememberProduct() {
      try {
        const key = 'theme:recently-viewed-products';
        const old = JSON.parse(localStorage.getItem(key) || '[]');
        const items = (Array.isArray(old) ? old : []).filter(id => String(id) !== String(this.config.productId));
        items.unshift(this.config.productId); localStorage.setItem(key, JSON.stringify(items.slice(0, 40)));
      } catch (_) { /* Storage may be disabled by the browser or privacy preferences. */ }
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    

/* FOEN Cart V1.4 UI only: Prestige remains responsible for quantity, note, discount and cart requests. */

if (!customElements.get('foen-cart-experience-v14')) {

  customElements.define('foen-cart-experience-v14', class extends HTMLElement {

    connectedCallback() {

      if (this.controller) return;

      this.controller = new AbortController();

      const signal = this.controller.signal;

      this.schedule = this.schedule.bind(this);

      this.addEventListener('click', event => {

        if (!(event.target instanceof Element) || !event.target.closest('[data-foen-sticky-checkout]')) return;

        event.preventDefault();

        const button = this.querySelector('[data-foen-main-checkout]');

        const form = this.querySelector('[data-foen-cart-form]');

        if (!button || !form || button.disabled) return;

        // Always pass the real name="checkout" submitter; never post a second cart request.

        if (typeof form.requestSubmit === 'function') form.requestSubmit(button);

        else button.click();

      }, { signal });

      this.addEventListener('focusin', this.schedule, { signal });

      this.addEventListener('focusout', this.schedule, { signal });

      window.addEventListener('scroll', this.schedule, { passive: true, signal });

      window.addEventListener('resize', this.schedule, { passive: true, signal });

      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });

      ['cart:change','line-item:change','dialog:after-show','dialog:after-hide'].forEach(name => {

        document.addEventListener(name, this.schedule, { signal });

      });

      this.mutations = new MutationObserver(this.schedule);

      this.mutations.observe(this, { childList: true, subtree: true, characterData: true });

      this.schedule();

    }

    disconnectedCallback() {

      this.controller?.abort();

      this.controller = null;

      this.mutations?.disconnect();

      this.checkoutObserver?.disconnect();

      this.sizeObserver?.disconnect();

      cancelAnimationFrame(this.frame);

      this.frame = 0;

      this.observedCheckout = null;

    }

    schedule() {

      if (this.frame || !this.isConnected) return;

      this.frame = requestAnimationFrame(() => {

        this.frame = 0;

        if (this.isConnected) this.refresh();

      });

    }

    refresh() {

      const checkout = this.querySelector('[data-foen-main-checkout]');

      const recap = this.querySelector('.foen-cart-recap-inner');

      const sticky = this.querySelector('[data-foen-sticky-cart]');

      const total = this.querySelector('[data-foen-cart-total]');

      const stickyTotal = this.querySelector('[data-foen-sticky-total]');

      if (total && stickyTotal) {

        const text = total.textContent.trim();

        if (text !== stickyTotal.textContent.trim()) stickyTotal.textContent = text;

      }

      if (checkout !== this.observedCheckout) {

        this.observedCheckout = checkout;

        this.checkoutObserver?.disconnect();

        this.sizeObserver?.disconnect();

        if (checkout && 'IntersectionObserver' in window) {

          this.checkoutObserver = new IntersectionObserver(this.schedule, { threshold: [0, .1, 1] });

          this.checkoutObserver.observe(checkout);

        }

        if (recap && 'ResizeObserver' in window) {

          this.sizeObserver = new ResizeObserver(this.schedule);

          this.sizeObserver.observe(recap);

        }

      }

      if (recap) {

        const header = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-area-height')) || 0;

        const tall = recap.offsetHeight > window.innerHeight - header - 40;

        if (recap.hasAttribute('data-foen-tall') !== tall) recap.toggleAttribute('data-foen-tall', tall);

      }

      if (!sticky) return;

      if (!checkout || !this.querySelector('.foen-cart-item') || window.innerWidth >= 900) {

        sticky.hidden = true;

        return;

      }

      const rect = checkout.getBoundingClientRect();

      const viewport = window.visualViewport;

      const top = viewport?.offsetTop || 0;

      const bottom = top + (viewport?.height || window.innerHeight);

      const checkoutVisible = rect.bottom > top && rect.top < bottom;

      const active = document.activeElement;

      const typing = active instanceof Element && this.contains(active) && active.matches('textarea,select,input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"])');

      const keyboard = viewport && window.innerHeight - viewport.height > 150;

      const overlay = document.querySelector('dialog[open],cart-drawer[open],x-drawer[open],x-modal[open],.drawer[open],.modal[open],.pswp--open');

      const footer = document.querySelector('footer');

      const footerVisible = footer && footer.getBoundingClientRect().top < bottom;

      sticky.hidden = Boolean(checkoutVisible || typing || keyboard || overlay || footerVisible);

      const stickyButton = sticky.querySelector('[data-foen-sticky-checkout]');

      if (stickyButton) stickyButton.disabled = checkout.disabled;

    }

  });

}


  } catch(e) { console.error(e); }
})();
})();
